import { FC } from 'react';
import { useDispatch } from 'react-redux';
import {
    resetProgress,
    setIsAddPhotoWidgetOpen,
} from '@/store/slices/progressSlice';
import IcoInfo from '@/assets/svg/ico_info.svg?react';
import Button from '@/components/controls/Button/Button.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import { MODAL_SHEET_SIZES } from '@/components/interactive/ModalSheet/ModalSheet.config';
import styles from '@/components/widgets/ProgressWidget/LoadFallModal/LoadFallModal.module.scss';

const LoadFallModal: FC = () => {
    const dispatch = useDispatch();

    const closeHandler = (isOpenBottomSheet?: boolean): void => {
        dispatch(resetProgress());

        if (isOpenBottomSheet) {
            dispatch(setIsAddPhotoWidgetOpen(true));
        }
    };

    return (
        <ModalSheet
            size={MODAL_SHEET_SIZES.Small}
            onClose={closeHandler}
            dataTest="load_fall_modal"
        >
            <div className={`flcol flc ${styles.modalBody}`}>
                <IcoInfo />
                <span className={styles.content}>
                    При загрузке произошла
                    <br /> ошибка, изделия
                    <br /> не добавились в гардероб
                </span>
                <Button
                    dataTest="load_fall_modal_button"
                    clickHandler={() => closeHandler(true)}
                >
                    Попробовать еще
                </Button>
            </div>
        </ModalSheet>
    );
};

export default LoadFallModal;
